import * as cx from 'classnames';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

interface OwnProps {
    name?: string;
    className?: string;
    errors?: string[];
    label?: string;
    htmlFor?: string;
    showError?: boolean;
}

const FieldWrapper: React.StatelessComponent<OwnProps> = ({
    name, className, errors, label, htmlFor, showError = true, children,
}) => (
    <div className={cx('field-wrapper', className, name, errors && errors.length && 'error')}>
        {label && <label htmlFor={htmlFor}>{label}</label>}
        {children}
        <TransitionGroup>
            {showError && errors && errors.length && (
                <CSSTransition
                    classNames="slide-in"
                    timeout={300}
                >
                    <div className="g-form-errors">
                        {errors.map((error, index) => (
                            <div key={index} className="error-msg" dangerouslySetInnerHTML={{__html: error}} />
                        ))}
                    </div>
                </CSSTransition>
            )}
        </TransitionGroup>
    </div>
);

FieldWrapper.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.string),
    // label element content
    label: PropTypes.string,
    // for="" attribute for label
    htmlFor: PropTypes.string,
    showError: PropTypes.bool,
};

export default FieldWrapper;
